<template>
  <div class="header FTG-info-Menu AboutHeader">
    <Layout>
      <Header>
        <Menu mode="horizontal" theme="dark" :active-name="type">
          <div class="layout-nav SelectNone">
            <MenuItem :to="{path: '/'}" name="2">Works</MenuItem>
            <MenuItem :to="{path: '/about'}" name="3">About</MenuItem>
            <MenuItem :to="{path: '/contact'}" name="4">Contact</MenuItem>
            <div class="Clear"></div>
          </div>

          <Icon @click="showMenu()" class="HeaderMenu aboutHeaderMenu" type="md-menu" />
        </Menu>
      </Header>
    </Layout>


    <Modal v-model="menuModal" class="MenuModal" :styles="{top: '0px'}">
      <Button @click.native="toPage('/')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">Works</Button>
      <Button @click.native="toPage('/about')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">About</Button>
      <Button @click.native="toPage('/contact')" class="singalBtn" type="text">Contact</Button>
    </Modal>
  </div>
</template>

<script>
export default {
  props: ["type"],
  name: 'infoHeader',
  data () {
    return {
      menuModal: false
    }
  },
  methods: {
    showMenu(){
      this.menuModal = true
    },
    toPage(_path){
      this.$router.push({path: _path})
    }
    
  },
  mounted() {

  },
  watch:{
    
  }
}
</script>

<style scoped lang="less">
  @import './component.less';
  .aboutHeaderMenu {
    color: #515a6e !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/aboutHeader.vue